import React, {useState, useEffect} from 'react';
import TextInput from '../common/generic/TextInput';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { TitleBar } from '../common/theme';
import { getCreateFeildStatus, dashboardDomain } from '../../ApiHelper';
import Dialog from '../common/Dialog';
import { replaceAll } from '../../Utils';
import axios from 'axios';

const MailAddress = ({showEmailWindow, setShowEmailWindow, request, customer}) =>{
  const [typeAddress,setTypeAddress] = useState('');
  const saveClicked = async () => {
    const currentAddress = customer.NAME + ', ' + customer.District + ', ' + customer.CITY + ', ' + customer.PROV + ', ' + customer.COUNTRY + ', ' + customer.POSTAL + '%0A' +customer.URL_NUM+' :: %0A%0A';
    let params = replaceAll(currentAddress+typeAddress,'\n','%0A');
    params = replaceAll(params,'#','(NumberSign)');
    params = replaceAll(params,'&','(andSign)');
    params = replaceAll(params,'+','(plusSign)');
    params = replaceAll(params,'?','(questionMark)');
    params = replaceAll(params,':','(collon)');
    params = replaceAll(params,';','(semiCollon)');
    params = replaceAll(params,'_','(underscore)');
    params = replaceAll(params,'/','(forwardSlash)');
    params = replaceAll(params,'$','(dollarSign)');

    let query = {
      params,
      secToken: sessionStorage.getItem('token'),
      userID: sessionStorage.getItem('userID'),
      func:'sendSESMail',
    };
    const response = await axios.get(`${dashboardDomain}code/database.php?function=${query.func}&params=${query.secToken}-invalid~${query.userID}~${query.params}`);

    let msg = 'A message has been sent to Essential Skills to change your address. We will contact your email if we require further assistance.';
    window.alert(msg);
  };

  const cancelClicked = () => {
    setShowEmailWindow(false);
  };

  return(<>
    Please tell us what you want changed in your school address.
    <Row className='form-group'>
      <textarea style={{resize: 'none'}} className="form-control textFont" rows="5" onChange={e => setTypeAddress(e.target.value)} value={typeAddress}></textarea>
    </Row>
    <Row><Col>
          <span className={'pull-right'}>
          <Button onClick={saveClicked} variant="success"> Send Message </Button>&nbsp;
          <Button onClick={cancelClicked} variant="danger"> Cancel </Button>
          </span>
    </Col></Row>    
  </>);
};

const TextInputButton = ({ name, label, placeholder, buttonCallback, ...rest }) => 
  <Row className='form-group'>
  <Col xs='2' style={{fontWeight:'bold'}} ><label htmlFor={name}>{label}</label></Col>
  <Col xs='8'>
  <input
      id = {name}
      name={name}
      className="form-control"
      {...rest}
  />
  </Col> 
  <Col xs='2'><Button variant={'success'} onClick={()=>buttonCallback(name)}>Edit</Button></Col>
  </Row>;

const EnterPassword = ({ componentData }) => {
  const {customer, schoolPass,setSchoolPass,adminName,setAdminName,adminPass,setAdminPass} = componentData;

  const [typeUser,setTypeUser] = useState('');
  const [typePass,setTypePass] = useState('');
  const [typePassAgain,setTypePassAgain] = useState('');

  const [typeSchoolAdminPass,setTypeSchoolAdminPass] = useState('');
  const [typeNewSchoolPass,setTypeNewSchoolPass] = useState('');
  const [typeNewSchoolAgain,setTypeNewSchoolAgain] = useState('');  

  const [typeAdminLogin,setTypeAdminLogin] = useState('');
  const [typeAdminLoginPass,setTypeAdminLoginPass] = useState('');
  const [dialog, setDialog] = useState({show:false});

  const saveClicked = () =>{

    let query = '';
    if(componentData.type === 'adminPass'){
      query = {
        params:`${customer.ID}~${typePass}`,
        func:'saveTeacherPass'   
      };
      if(typePass!==typePassAgain)
        query.error = 'Passwords don\'t match';
      if(typeUser !== adminPass)  
        query.error = 'Invalid Admin Password';
      if(typePass === '')  
        query.error = 'Password Required';

      let status = getCreateFeildStatus('Admin Password',typePass, false);
      if(status.error) query.error = status.error;

      if(!query.error){
        customer.TEACHER_PASS = typePass;
        setAdminPass(typePass);
      }
      else
        setDialog({title:'Problem with the Admin Password', text:query.error, show:true});
    }
    if(componentData.type === 'adminLogin'){
      query = {
        params:`${customer.ID}~${typeAdminLogin}`,
        func:'saveTeacherLogin'   
      };
      if(typeAdminLoginPass !== adminPass)  
        query.error = 'Invalid Password';
      if(typeAdminLogin === '')  
        query.error = 'Username Name Required';

      let status = getCreateFeildStatus('Admin Username',typeAdminLogin, false);
      if(status.error) query.error = status.error;
      
      if(!query.error){
        customer.TEACHER_LOGIN = typeAdminLogin;
        setAdminName(typeAdminLogin);
      }
      else
        setDialog({title:'Problem with the Admin Username', text:query.error, show:true});
    }
    if(componentData.type === 'schoolPass'){
      query = {
        params:`${customer.ID}~${typeNewSchoolPass}`,
        func:'saveSchoolPass'   
      };
      if(typeNewSchoolPass!==typeNewSchoolAgain)
        query.error = 'Passwords don\'t match';
      if(typeSchoolAdminPass !== adminPass)  
        query.error = 'Invalid Admin Password'; 
      if(typeNewSchoolPass === '')  
        query.error = 'School Password Required';
        
      let status = getCreateFeildStatus('School Password',typeNewSchoolAgain, false);
      if(status.error) query.error = status.error;        
        
      if(!query.error){
        customer.SCHOOL_PASS = typeNewSchoolPass;
        setSchoolPass(typeNewSchoolPass);
      }
      else
        setDialog({title:'Problem with the School Password', text:query.error, show:true});
    }

    if(query.error){
      console.log(query.error);
      return;
    }
    componentData.request(query); 
    componentData.fn(componentData.type); // close the window
  };  

  return(<>
    <div className={'card'}>
      <div className={'card-body'}>
        {(componentData.type === 'schoolPass') && <>
          <TextInput onChange={e=>setTypeSchoolAdminPass(e.target.value)} value={typeSchoolAdminPass} type="password" label="Enter your Admin Password:" />
          <TextInput onChange={e=>setTypeNewSchoolPass(e.target.value)} value={typeNewSchoolPass} type="password" label="New School Password:" />
          <TextInput onChange={e=>setTypeNewSchoolAgain(e.target.value)} value={typeNewSchoolAgain} type="password" label="Verify School Password:" />
        </>}
        {(componentData.type === 'adminLogin') && <>
          <TextInput onChange={e=>setTypeAdminLoginPass(e.target.value)} value={typeAdminLoginPass} type="password" label="Enter your Admin Password:" />
          <TextInput onChange={e=>setTypeAdminLogin(e.target.value)} value={typeAdminLogin} label="New Username:" />
        </>}
        {(componentData.type === 'adminPass') && <>
          <TextInput onChange={e=>setTypeUser(e.target.value)} value={typeUser} type="password" label="Enter your Admin Password:" />
          <TextInput onChange={e=>setTypePass(e.target.value)} value={typePass} type="password" label="New Admin Password:" />
          <TextInput onChange={e=>setTypePassAgain(e.target.value)} value={typePassAgain} type="password" label="Verify Admin Password:" />
        </>}
        <Row><Col>
          <span className={'pull-right'}>
          <Button onClick={saveClicked} variant="success"> Save </Button>&nbsp;
          <Button onClick={()=>componentData.fn(componentData.type)} variant="danger"> Cancel </Button>
          </span>
        </Col></Row>
      </div>
  </div>
  <Dialog dialogState={{dialog, setDialog}} />
  </>);
};

const ProfilePage = ({pageState}) => {  
  const {customer, request} = pageState;
  const [showEmailWindow, setShowEmailWindow] = useState(false);

  const [contactName,setContactName] = useState('');
  const [contactPhone,setContactPhone] = useState('');
  const [contactEmail,setContactEmail] = useState('');

  const [schoolID,setSchoolID] = useState('');
  const [schoolPass,setSchoolPass] = useState('');
  const [adminName,setAdminName] = useState('');
  const [adminPass,setAdminPass] = useState('');

  const [schoolName,setSchoolName] = useState('');
  const [districtName,setDistrictName] = useState('');
  const [cityName,setCityName] = useState('');
  const [stateName,setStateName] = useState('');
  const [country,setCountry] = useState('');
  const [zip,setZip] = useState('');

  const [editContact, setEditContact] = useState(false);
  const [showSchoolPassDialog, setSchoolPassDialog] = useState(false);
  const [showAdminLoginDialog, setAdminDialog] = useState(false);
  const [showAdminPassDialog, setAdminPassDialog] = useState(false);
  const [dialog, setDialog] = useState({show:false});

  useEffect(() => {

    if(schoolID==='' && customer){
      setSchoolID(customer.URL_NUM);

      setContactName(customer.CONTACT_NAME);
      setContactPhone(customer.CONTACT_PHONE);
      setContactEmail(customer.CONTACT_EMAIL);

      setSchoolPass(customer.SCHOOL_PASS);
      setAdminName(customer.TEACHER_LOGIN);
      setAdminPass(customer.TEACHER_PASS);

      setSchoolName(customer.NAME);
      setDistrictName(customer.District);
      setCityName(customer.CITY);
      setStateName(customer.PROV);
      setCountry(customer.COUNTRY);
      setZip(customer.POSTAL);
    }
  });

  const editPassClicked = (open) => (type) => {
    (type === 'schoolPass') && setSchoolPassDialog(open);
    (type === 'adminLogin') && setAdminDialog(open);
    (type === 'adminPass') && setAdminPassDialog(open);
  };

  const saveContacts = () =>{

    let query = {
        params:`${customer.ID}~${contactName}~${contactPhone}~${contactEmail}`,
        func:'saveCustomerContact'   
    };

    let statusName = getCreateFeildStatus('Name',contactName, true);
    if(statusName.error){
      setDialog({title:'Problem with the Name...', text:statusName.error, show:true});
      return;
    }

    let statusEmail = getCreateFeildStatus('Email',contactEmail, false);
    if(statusEmail.error){
      setDialog({title:'Problem with the Email...', text:statusEmail.error, show:true});
      return;
    }

    let statusPhone = getCreateFeildStatus('Email',contactPhone, false);
    if(statusPhone.error){
      setDialog({title:'Problem with the Phone field...', text:statusPhone.error, show:true});
      return;
    }

    customer.CONTACT_NAME = contactName;
    customer.CONTACT_EMAIL = contactEmail;
    customer.CONTACT_PHONE = contactPhone;
    request(query); 
    setEditContact(false);
  };

  const cancelContacts = () =>{
    setContactName(customer.CONTACT_NAME);
    setContactPhone(customer.CONTACT_PHONE);
    setContactEmail(customer.CONTACT_EMAIL);    
    setEditContact(false);
  };  

  return (
    <>    
        <Form>
            <TitleBar>
                <Col  style={{textAlign: 'left', color: 'white' }} xs='12'><h3>Subscription Administrator</h3></Col>   
            </TitleBar>
            <br/>
            <TextInput onChange={e=>setContactName(e.target.value)} disabled={!editContact} name="name" label="Name:" value={contactName}/>
            <TextInput onChange={e=>setContactEmail(e.target.value)} disabled={!editContact} name="email" label="Email:" value={contactEmail}/>
            <TextInput onChange={e=>setContactPhone(e.target.value)} disabled={!editContact} name="phone" label="Phone:" value={contactPhone}/>
            {!editContact && <><Button onClick={()=>setEditContact(true)} variant={'success'} > Edit </Button> </>}
            {editContact && <>
            <Button variant={'success'} onClick={saveContacts}> Save </Button> &nbsp;
            <Button variant={'danger'} onClick={cancelContacts} > Cancel </Button> 
            </>}
            <br/><br/>
            <TitleBar>
                <Col  style={{textAlign: 'left', color: 'white' }} xs='12'><h3>Credentials</h3></Col>   
            </TitleBar>
            <br/>            
            <TextInput name="schoolID" label="School ID:" disabled value={schoolID}/>
            <br/>

            <TextInputButton type="text" name="adminLogin" label="Admin Username:" buttonCallback={editPassClicked(true)} disabled onChange={e=>setAdminName(e.target.value)} value={adminName}/>
            {showAdminLoginDialog && <EnterPassword componentData={{customer, schoolPass,setSchoolPass,adminName,setAdminName,adminPass,setAdminPass,request, type:'adminLogin', fn:editPassClicked(false)}}/> }
            <TextInputButton type="password" name="adminPass" label="Admin Password:" buttonCallback={editPassClicked(true)} disabled onChange={e=>setAdminPass(e.target.value)} value={adminPass}/>
            {showAdminPassDialog && <EnterPassword componentData={{customer, schoolPass,setSchoolPass,adminName,setAdminName,adminPass,setAdminPass,request, type:'adminPass', fn:editPassClicked(false)}}/> }
            <TextInputButton type="password" name="schoolPass" label="School Password:" buttonCallback={editPassClicked(true)} disabled onChange={e=>setSchoolPass(e.target.value)} value={schoolPass}/>
            {showSchoolPassDialog && <EnterPassword componentData={{customer, schoolPass,setSchoolPass,adminName,setAdminName,adminPass,setAdminPass,request, type:'schoolPass', fn:editPassClicked(false)}}/> }

            <TitleBar>
                <Col  style={{textAlign: 'left', color: 'white' }} xs='12'><h3>Address</h3></Col>  
            </TitleBar> 
            <br/>
            <TextInput name="school" label="School:" disabled onChange={e=>setSchoolName(e.target.value)} value={schoolName}/>
            <TextInput name="district" label="District:" disabled onChange={e=>setDistrictName(e.target.value)} value={districtName}/>
            <TextInput name="city" label="City:" disabled onChange={e=>setCityName(e.target.value)} value={cityName}/> 
            <TextInput name="state" label="State/Prov:" disabled onChange={e=>setStateName(e.target.value)} value={stateName}/>
            <TextInput name="country" label="Country:" disabled onChange={e=>setCountry(e.target.value)} value={country}/>
            <TextInput name="zip" label="Zip/Postal:" disabled onChange={e=>setZip(e.target.value)} value={zip}/> 

            <Button variant={'success'} onClick={()=>setShowEmailWindow(true)} > Request Update </Button>  
            <br/> 
            {showEmailWindow && <MailAddress showEmailWindow={showEmailWindow} setShowEmailWindow={setShowEmailWindow} request={request} customer={customer}/> }
        </Form>
        <Dialog dialogState={{dialog, setDialog}} />
    </>
  );
};

export default ProfilePage;